import { HeaderCommonProps } from "@components/Header/types";
import { useUserInfo } from "@features/mySph/hooks/useUserInfo";
import MyAccountUserHeader from "@routes/MyAccount/components/MyAccountHeader/MyAccountUserHeader";
import { cn } from "@util/helpers";

/**
 * MyAccountHeader component displays in the header section as trigger to login or display user profile.
 */
const MyAccountHeader = ({
  textClassName,
  userIconStrokeColor,
}: Pick<
  HeaderCommonProps,
  "textClassName" | "userIconStrokeColor"
>): React.ReactElement => {
  const { isSubscriber } = useUserInfo();

  return (
    <div
      className="relative ml-3 flex-none"
      data-testid="my-account-header-component"
    >
      <div className={cn("relative z-10", { "lg:mr-4": !isSubscriber })}>
        <MyAccountUserHeader
          textClassName={textClassName}
          userIconStrokeColor={userIconStrokeColor}
        />
      </div>
    </div>
  );
};

export default MyAccountHeader;
